export default __webpack_public_path__ + "static/media/recycle-logo.6639a8f7.png";